import type { UserDataType } from '@/src/context/types'
import type { RestoUser } from '@/src/store/apps/resto365UserManagement'

/** Maps `/resto365-user/me` payload to the shape stored in `AuthContext` (same as login/callback). */
export function mapRestoUserToAuthUser(me: RestoUser): UserDataType {
  return {
    id: me.id,
    email: me.email,
    role: me.role,
    fullName: me.name,
    username: me.name,
    permissions: me.permissions,
    restaurants: me.restaurants,
    countries: me.countries,
    areas: me.areas
  }
}
